import { Navigate } from 'react-router-dom';
import authService from '../services/authService';
import { useIsClientPortal } from '../hooks/useIsClientPortal';
import { usePortalName } from '../hooks/usePortalName';

function MemberPrivateRoute({ children }: React.PropsWithChildren): any {
  const portalName = usePortalName();
  const federatedProvider = authService.getFederatedCustomProvider(portalName);

  if (!authService.isLoggedIn()) {
    const landingPage = federatedProvider ? '/clientLogin' : '/login';
    return <Navigate to={landingPage} />;
  }
  return children;
}

export default MemberPrivateRoute;
